import React from "react";
import { connect } from "react-redux";

import {
  getExternalCashlessName,
  getStudentSchoolID
} from "state/school_money/selectors";

import { removeCreditTopUpFromBasket } from "state/school_money/actions";

import Currency from "components/Currency";
import RemoveButton from "components/school_money/RemoveButton";

import "./CreditTopUp.css";

class CreditTopUp extends React.Component {

  getLabel() {
    switch (this.props.creditType) {
      case "dinner_money":
        return "Dinner Credit Top Up";
      case "club_extended_services":
        return "Club Credit Top Up";
      case "external_top_up":
        return this.props.externalCashlessName + " Top Up";
      default:
        return "Credit Top Up";
    }
  }

  render() {
    return (
      <div className="credit-basket-item-detail">
        <div className="credit-basket-item-detail__label">{this.getLabel()}</div>
        <div className="credit-basket-item-detail__price">
          <Currency className="credit-basket-item-detail__amount" amount={this.props.amount} />
          <RemoveButton className="credit-basket-item-detail__remove-button" onClick={this.props.remove} />
        </div>
      </div>
    )
  }

}

export default connect(
  (state, { studentID }) => ({
    externalCashlessName: getExternalCashlessName(state, getStudentSchoolID(state, studentID))
  }),
  (dispatch, { creditType, studentID }) => ({
    remove: () => dispatch(removeCreditTopUpFromBasket(creditType, studentID))
  })
)(CreditTopUp);



// WEBPACK FOOTER //
// ./src/components/school_money/basket/items/creditTopUp/CreditTopUp.js